/**
 * Centralized data for all legal pages.
 * To configure for production, replace these values OR move them to
 * REACT_APP_* env vars and read from process.env.
 */
export const COMPANY = {
  name: "BAYO MAG",
  legalForm: "Association loi 1901",
  capital: "—", // N/A pour association
  address: "Stains (93240), France",
  registration: "SIRET 934 254 004 00013",
  vat: "Non assujetti à la TVA (article 261-7 du CGI)",
  publisher: "Donald EDMOND",
  email: "hello@bayo-mag.com",
  phone: "—",
  hosting: {
    name: "Emergent Labs",
    address: "Hébergement cloud Kubernetes — Emergent",
    contact: "support@emergent.sh",
  },
  shippingPartners: "Colissimo, Mondial Relay",
  shippingZone: "France métropolitaine, Union Européenne",
  shippingDelay: "3 à 7 jours ouvrés",
  shippingPriceFrom: "4,90 €",
  returnDays: 14,
  effectiveDate: "2025-02-01",
};
